<template>
  <div class="content-sidebar" :class="{closed: !opened}">
    <div class="d-flex flex-column">
      <Tab v-for="tab in tabs" :key="tab.id"
        :active="tab.id === active"
  
        :id="tab.id"
        @click.native="active = tab.id"
      >
        <slot :name="`icon-${tab.id}`"></slot>

        <transition
          @enter="enter"
          @leave="leave"
        >
          <div v-if="opened">
            {{ tab.name }}
          </div>
        </transition>
      </Tab>
    </div>

    <slot></slot>
  </div>
</template>

<script>

import Tab from "./Tab.vue"

import transitionFunctionConstructor from "../../../../../mixins/transitionFunctionConstructor"

export default {
  mixins: [
    transitionFunctionConstructor(),
  ],
  components: {
    Tab,
  },
  props: {
    tabs: Array,
    value: String,
    opened: Boolean,
  },
  data() {
    return {
      active: null,
    }
  },
  created() {
    if (!this.active && this.tabs && this.tabs[0]) {
      this.active = this.tabs[0].id
    }
  },
  watch: {
    active(val) {
      this.$emit("input", val)
    },
    value(val) {
      this.active = val
    },
  },
}

</script>

<style scoped>

.content-sidebar {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  
  flex-shrink: 0;
  border-right: 1px solid #E3E3E3;
  padding-right: 15px;
  padding-left: 15px;
  padding-top: 15px;
  transition-duration: .15s;
}

.closed {
  width: 50px;
}

</style>

